import { Component, computed, ElementRef, input, output, viewChild } from '@angular/core';
import { elementWidthSignal, measureRenderedTextWidth } from '../../utils/dom.utils';
import { RidAudioButton } from '../rid-audio-button/rid-audio-button';

const AUTO_TEXT_SIZE_CLASSES = ['text-4xl', 'text-3xl', 'text-2xl', 'text-xl'] as const;

@Component({
  selector: 'rid-content-card',
  imports: [RidAudioButton],
  templateUrl: './rid-content-card.html',
  host: {
    class: 'block',
    '[class.h-full]': 'fullHeight()',
    '[class.w-full]': 'fullWidth()',
  },
})
export class RidContentCard {
  image = input<string>();
  text = input<string>();
  audio = input<string | { pronounce: string }>();
  state = input<'DEFAULT' | 'CORRECT' | 'INCORRECT' | 'DISABLED'>('DEFAULT');
  layout = input<'VERTICAL' | 'HORIZONTAL'>('VERTICAL');
  fullHeight = input<boolean>(false);
  fullWidth = input<boolean>(false);
  autoSizeText = input<boolean>(false);

  contentCardText = viewChild<ElementRef<HTMLElement>>('contentCardText');
  textAreaSize = elementWidthSignal(this.contentCardText);

  autoTextSizeClass = computed(() => {
    if (!this.autoSizeText()) return AUTO_TEXT_SIZE_CLASSES[0];

    const text = this.text();
    const width = this.textAreaSize()?.width;

    if (!text || !width) return AUTO_TEXT_SIZE_CLASSES[AUTO_TEXT_SIZE_CLASSES.length - 1];

    const fit = AUTO_TEXT_SIZE_CLASSES.find((cls) => measureRenderedTextWidth(text, `${cls} font-default font-normal`) <= width);
    return fit ?? AUTO_TEXT_SIZE_CLASSES[AUTO_TEXT_SIZE_CLASSES.length - 1];
  });

  audioButton = viewChild<RidAudioButton>('audioButton');

  // clickable
  isClickable = input<boolean>(false);
  isClicked = input<boolean>(false);
  clicked = output<void>();

  twBackground = computed(() => {
    const state = this.state();

    if (state === 'DISABLED') return 'bg-surface-300';

    if (state === 'DEFAULT') {
      if (this.isClickable()) {
        return 'cursor-pointer bg-surface-300 hover:bg-blue-500';
      } else return 'bg-surface-300';
    } else {
      return {
        CORRECT: 'bg-emerald-500',
        INCORRECT: 'bg-red-500',
      }[state];
    }
  });

  async present() {
    await this.audioButton()?.play();
  }
}
